// Single-open accordion for .ecw-faq (ECW FAQ Accordion widget).
// Opening an item closes whichever one was previously open.

export function initFaqAccordion() {
  const lists = document.querySelectorAll('[data-ecw-faq]');
  if (!lists.length) return;

  lists.forEach((list) => {
    const items = Array.from(list.querySelectorAll('[data-ecw-faq-item]'));

    items.forEach((item) => {
      const button = item.querySelector('.ecw-faq__question');
      if (!button) return;

      button.addEventListener('click', () => {
        const willOpen = !item.classList.contains('is-open');

        items.forEach((other) => {
          other.classList.remove('is-open');
          other.querySelector('.ecw-faq__question')?.setAttribute('aria-expanded', 'false');
        });

        if (willOpen) {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
}
